import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayoutBasic from "./layouts/DashboardLayoutBasic";
import PrivateRoute from "./config/PrivateRoute";
import PublicRoute from "./config/PublicRoute";

import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import LegalFile from "./pages/LegalFile";
import LegalFileHome from "./pages/LegalFileHome";
import LegalFileAttachment from "./pages/LegalFileAttachment";
import NewLegalFile from "./pages/NewLegalFile";
import User from "./pages/User";
import Lawyer from "./pages/Lawyer";
import Report from "./pages/Report";
import PaymentOrder from "./pages/PaymentOrder";
import Security from "./pages/Security";
import Role from "./pages/Role";
import JobHistory from "./pages/JobHistory";
import ContributorArca from "./pages/ContributorArca";
import Lawsuit from "./pages/Lawsuit";
import Party from "./pages/Party";
import Client from "./pages/Client";
import JudicialAccount from "./pages/JudicialAccount";
import Settings from "./pages/Settings";
import SettingsLiquidation from "./pages/SettingsLiquidation";
import SettingsLawsuitTaxStatus from "./pages/SettingsLawsuitTaxStatus";
import Liquidations from "./pages/Liquidations";
import Branches from "./pages/Branches";
import SettingsAttachmentTypes from "./pages/SettingsAttachmentTypes";
import SettingsOperationTypes from "./pages/SettingsOperationTypes";
import SettingsLegalFileStages from "./pages/SettingsLegalFileStages";
import SettingsSentenceMarkers from "./pages/SettingsSentenceMarkers";
import SettingsAttachmentSources from "./pages/SettingsAttachmentSources";
import NotificationCertificates from "./pages/NotificationCertificates";
import AuditLogs from "./pages/AuditLogs";
import Workspace from "./pages/Workspace";
import WorkspaceTaskDetail from "./pages/WorkspaceTaskDetail";

import ChargeLegalFile from "./components/LegalFile/ChargeLegalFile";
import ManagerLegalFile from "./components/LegalFile/ManagerLegalFile";
import LegalFileDetail from "./components/LegalFile/LegalFileDetail";
import ReportLegalFile from "./components/LegalFile/ReportLegalFile";
import ChargeNumberReport from "./components/LegalFile/ChargeNumberReport";
import FailedLegalFile from "./components/LegalFile/FailedLegalFile";
import SearchLegalFile from "./components/LegalFile/SearchLegalFile";
import FailedLegalFileReportByDate from "./components/Reports/FailedLegalFileReportByDate";

import ManagerLegalFileAttachment from "./components/LegalFileAttachment/ManagerLegalFileAttachment";
import ManagerLegalFileDocument from "./components/LegalFileAttachment/ManagerLegalFileDocument";
import Auctioneers from "./pages/Auctioneers";
import AportesAttachmentsManager from "./components/LegalFileAttachment/AportesAttachmentsManager";
import GenerateUploadAttachments from "./components/LegalFileAttachment/GenerateUploadAttachment";
import UploadSacAttachment from "./components/LegalFileAttachment/UploadSacAttachment";

import GenerateNewsFileLegal from "./components/NewLegalFile/GenerateNewsFileLegal";
import NewsLegalFileErrorsTable from "./components/NewLegalFile/NewsLegalFileErrorsTable";

import GeneratePaymentOrderByLawyer from "./components/PaymentOrder/GeneratePaymentOrderByLawyer";
import ManagerPaymentOrder from "./components/PaymentOrder/ManagerPaymentOrder";
import ChargeNumberLegalFilePayment from "./components/PaymentOrder/ChargeNumberLegalFilePayment";

import OrderPaymentReportByDate from "./components/Reports/OrderPaymentReportByDate";
import RetentionReport from "./components/Reports/RetentionReport";
import PaymentOrderReport from "./pages/PaymentOrderReport";
import ReportProcessedNewsFile from "./components/Reports/ReportProcessedNewsFile";
import ReportLegalFileBasic from "./components/Reports/ReportLegalFileBasic";
import ReportLawsuit from "./components/Reports/ReportLawsuit";
import ReportOperationsFile from "./components/Reports/ReportOperationsFile";
import ReportLegalFileAttachment from "./components/LegalFileAttachment/ReportLegalFileAttachment";

import ManagerContributorArca from "./components/ContributorArca/ManagerContributorArca";
import GenerateReportFileContributorArca from "./components/ContributorArca/GenerateReportFileContributor";
import ChargeFileArcaPeople from "./components/ContributorArca/ChargeFileArcaPeople";

import UploadLawsuit from "./components/Lawsuit/UploadLawsuit";
import ChargeLawsuit from "./components/Lawsuit/ChargeLawsuit";
import ManagerLawyerLawsuit from "./components/Lawsuit/ManagerLawyerLawsuit";
import ManagerLawsuit from "./components/Lawsuit/ManagerLawsuit";
import ManagerLawsuitFailure from "./components/Lawsuit/ManagerLawsuitFailure";
import ManagerUnlinkedLawsuit from "./components/Lawsuit/ManagerUnlinkedLawsuit";
import UploadHistoricalLawsuit from "./components/Lawsuit/UploadHistoricalLawsuit";
import UpdateLawsuitJucLegalFile from "./components/Lawsuit/UpdateLawsuitJucLegalFile";
import ChargeUpdateLawsuit from "./components/Lawsuit/ChargeUpdateLawsuit";
import ImportConcludedLawsuit from "./components/Lawsuit/ImportConcludedLawsuit";
import ChargeLawsuitLegalFile from "./components/Lawsuit/ChargeLawsuitLegalFile";

import PartySearch from "./components/Party/PartySearch";

import ChargeJudicialAccount from "./components/JudicialAccount/ChargeJudicialAccount";
import ChargeJudicialImport from "./components/JudicialImport/ChargeJudicialImport";
import ChargePaymentOrderImport from "./components/PaymentOrder/ChargePaymentOrderImport";
import GeneralSettings from "./components/Settings/GeneralSettings";
import ManagerLiquidations from "./components/Liquidation/ManagerLiquidations";
import ReportMunicipalitySheet from "./components/Liquidation/ReportMunicipalitySheet";
import ReportLiquidationSheet from "./components/Liquidation/ReportLiquidationSheet";
import ReportIndividualLiquidationSheet from "./components/IndividualLiquidation/ReportIndividualLiquidationSheet";
import SettingsIndividualLiquidation from "./pages/SettingsIndividualLiquidation";
import ManagerJudicialAccounts from "./components/JudicialAccount/ManagerJudicialAccount";
import ReportJudicialAccount from "./components/JudicialAccount/ReportJudicialAccount";

import UploadNotificationCertificate from "./components/NotificationCertificate/UploadNotificationCertificate";
import ManagerNotificationCertificate from "./components/NotificationCertificate/ManagerNotificationCertificate";
import ChargeFileUpdateDeleteNotificationCertificate from "./components/NotificationCertificate/ChargeFileUpdateDeleteNotificationCertificate";
import ReportNotificationCertificate from "./components/NotificationCertificate/ReportNotificationCertificate";
import ManagerNotificationCertificateFailure from "./components/NotificationCertificate/ManagerNotificationCertificateFailure";
import ManagerUnlinkedNotificationCertificate from "./components/NotificationCertificate/ManagerUnlinkedNotificationCertificate";
import ChargeGenerateNotificationCertificate from "./components/NotificationCertificate/ChargeGenerateNotificationCertificate";
import ScannerNotificationCertificate from "./components/NotificationCertificate/ScannerNotificationCertificate";
import UploadNotificationCertificateOnline from "./components/NotificationCertificate/UploadNotificationCertificateOnline";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Backdrop, CircularProgress, Box, Typography } from "@mui/material";
import { useLoading, LoadingProvider } from "./config/LoadingContext";
import { ToastProvider } from "./context/ToastContext";

function GlobalBackdrop() {
  const { open } = useLoading();

  return (
    <Backdrop
      open={open}
      sx={(theme) => ({
        zIndex: theme.zIndex.modal + 10,
        background:
          theme.palette.mode === "dark"
            ? "linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.72) 100%) !important"
            : "linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.14) 100%) !important",
        backdropFilter: "blur(16px)",
        WebkitBackdropFilter: "blur(16px)",
      })}
    >
      <Box
        sx={(theme) => ({
          minWidth: 180,
          px: 3,
          py: 2.5,
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.3,
          background:
            theme.palette.mode === "dark"
              ? "rgba(15,23,42,0.92)"
              : "rgba(255,255,255,0.62)",
          border:
            theme.palette.mode === "dark"
              ? "1px solid rgba(255,255,255,0.10)"
              : "1px solid rgba(255,255,255,0.5)",
          boxShadow: "0 18px 40px rgba(0,0,0,0.14)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
        })}
      >
        <CircularProgress
          size={36}
          thickness={4}
          sx={{
            color: "primary.main",
            filter: "drop-shadow(0 2px 8px rgba(25,118,210,0.28))",
          }}
        />
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: 14,
            color: "text.primary",
            letterSpacing: 0.2,
          }}
        >
          Procesando...
        </Typography>
      </Box>
    </Backdrop>
  );
}

function App() {
  return (
    <LoadingProvider>
      <ToastProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route path="/" element={<Login />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<DashboardLayoutBasic />}>
              <Route path="home" element={<Home />} />

              {/* Workspace / Área de Trabajo */}
              <Route element={<PrivateRoute requiredPermission="area de trabajo" />}>
                <Route path="workspace" element={<Workspace />} />
                <Route path="workspace/:id" element={<WorkspaceTaskDetail />} />
              </Route>

              {/* Expedientes */}
              <Route element={<PrivateRoute requiredPermission="expediente" />}>
                <Route path="legalFileHome" element={<LegalFileHome />} />
              </Route>
              
              <Route element={<PrivateRoute requiredPermission="expediente" />}>
                <Route path="legalFile" element={<LegalFile />} />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="buscar expediente" />
                }
              >
                <Route path="legal/file/search" element={<SearchLegalFile />} />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="ver detalle expediente" />
                }
              >
                <Route path="legal/file/:id" element={<LegalFileDetail />} />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="generar expediente" />
                }
              >
                <Route path="legalFile/charge" element={<ChargeLegalFile />} />
              </Route>
              <Route
                element={<PrivateRoute requiredPermission="ver expediente" />}
              >
                <Route
                  path="legalFile/manager"
                  element={<ManagerLegalFile />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="ver expediente fallido" />
                }
              >
                <Route path="legalFile/failed" element={<FailedLegalFile />} />
              </Route>

              {/* Adjuntos de Expedientes */}

              <Route
                element={
                  <PrivateRoute requiredPermission="archivos adjuntos expedientes" />
                }
              >
                <Route
                  path="legalFile/attachments/manager"
                  element={<ManagerLegalFileAttachment />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="generar multiples archivos adjuntos expediente" />
                }
              >
                <Route
                  path="legalFile/attachments/generate/upload"
                  element={<GenerateUploadAttachments />}
                />
              </Route>

              {/* <Route
                element={
                  <PrivateRoute requiredPermission="cargar multiples archivos adjuntos expediente" />
                }
              >
                <Route
                  path="legalFile/upload/attachments"
                  element={<UploadMultipleAttachmentsLegalFile />}
                />
              </Route> */}

              <Route
                element={
                  <PrivateRoute requiredPermission="subir escritos en linea sac" />
                }
              >
                <Route
                  path="legalFile/attachments/upload/sac"
                  element={<UploadSacAttachment />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver documentos expedientes" />
                }
              >
                {/* Adjuntos: sección propia, independiente de Escritos */}
                <Route
                  path="legalFile/documents"
                  element={<ManagerLegalFileDocument />}
                />
                {/* Ruta vieja: redirige para no romper accesos guardados */}
                <Route
                  path="legalFile/attachments/documents"
                  element={<Navigate to="/legalFile/documents" replace />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="cargar archivos planillas aportes expediente" />
                }
              >
                <Route
                  path="legalFile/upload/aportes"
                  element={<AportesAttachmentsManager />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="archivos adjuntos expedientes" />
                }
              >
                <Route
                  path="legalFile/attachments"
                  element={<LegalFileAttachment />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="reportes archivos adjuntos expedientes" />
                }
              >
                <Route
                  path="legalFile/attachments/report"
                  element={<ReportLegalFileAttachment />}
                />
              </Route>

              {/* Reportes */}
              <Route element={<PrivateRoute requiredPermission="reporte" />}>
                <Route path="legalFile/report/menu" element={<Report />} />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="exportar reporte expediente" />
                }
              >
                <Route path="legalFile/report" element={<ReportLegalFile />} />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="exportar reporte expediente archivo" />
                }
              >
                <Route
                  path="legalFile/report/file"
                  element={<ChargeNumberReport />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="exportar reporte expediente fallido" />
                }
              >
                <Route
                  path="legalFile/failed/report"
                  element={<FailedLegalFileReportByDate />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="exportar reporte basico expediente" />
                }
              >
                <Route
                  path="legalFile/report/basic"
                  element={<ReportLegalFileBasic />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="reporte cedula notificacion" />
                }
              >
                <Route
                  path="legalFile/report/operations"
                  element={<ReportOperationsFile />}
                />
              </Route>

              {/* Novedades */}
              <Route element={<PrivateRoute requiredPermission="novedades" />}>
                <Route path="legalFile/news" element={<NewLegalFile />} />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="generar novedades expediente" />
                }
              >
                <Route
                  path="legalFile/news/generate"
                  element={<GenerateNewsFileLegal />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="ver novedades expediente fallido" />
                }
              >
                <Route
                  path="legalFile/news/failed"
                  element={<NewsLegalFileErrorsTable />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="ver archivo novedades procesado" />
                }
              >
                <Route
                  path="legalFile/news/txt"
                  element={<ReportProcessedNewsFile />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="importar expediente judicial" />
                }
              >
                <Route
                  path="legalFile/judicial/import"
                  element={<ChargeJudicialImport />}
                />
              </Route>

              {/* Partes Legales */}
              <Route
                element={<PrivateRoute requiredPermission="partes legales" />}
              >
                <Route path="legalFile/parties" element={<Party />} />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="buscar partes legales" />
                }
              >
                <Route
                  path="legalFile/parties/search"
                  element={<PartySearch />}
                />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="ver clientes" />}
              >
                <Route path="legalFile/parties/clients" element={<Client />} />
              </Route>

              {/* Cuentas Judiciales */}
              <Route
                element={
                  <PrivateRoute requiredPermission="cuentas judiciales" />
                }
              >
                <Route
                  path="legalFile/judicial/accounts"
                  element={<JudicialAccount />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="generar cuentas judiciales" />
                }
              >
                <Route
                  path="legalFile/judicial/accounts/charge"
                  element={<ChargeJudicialAccount />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver cuentas judiciales" />
                }
              >
                <Route
                  path="legalFile/judicial/accounts/manager"
                  element={<ManagerJudicialAccounts />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="reporte cuentas judiciales" />
                }
              >
                <Route
                  path="legalFile/judicial/accounts/report"
                  element={<ReportJudicialAccount />}
                />
              </Route>

              {/* Cedulas de Notificación */}
              <Route
                element={
                  <PrivateRoute requiredPermission="cedulas notificacion" />
                }
              >
                <Route
                  path="legalFile/notification/certificates"
                  element={<NotificationCertificates />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="subir cedulas notificacion" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/upload"
                  element={<UploadNotificationCertificate />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="generar cedula notificacion" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/generate"
                  element={<ChargeGenerateNotificationCertificate />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver cedulas notificacion" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/manager"
                  element={<ManagerNotificationCertificate />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver cedulas notificacion" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/barcode"
                  element={<ScannerNotificationCertificate />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="eliminar cedulas notificacion" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/update"
                  element={<ChargeFileUpdateDeleteNotificationCertificate />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="reporte cedula notificacion" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/report"
                  element={<ReportNotificationCertificate />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver cedulas notificacion fallidas" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/failures"
                  element={<ManagerNotificationCertificateFailure />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver cedulas notificacion sin vincular" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/unlinked"
                  element={<ManagerUnlinkedNotificationCertificate />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="subir cedulas notificacion" />
                }
              >
                <Route
                  path="legalFile/notification/certificates/uploadOnline"
                  element={<UploadNotificationCertificateOnline />}
                />
              </Route>

              {/* Ordenes de pago */}
              <Route
                element={<PrivateRoute requiredPermission="orden de pago" />}
              >
                <Route path="paymentOrder" element={<PaymentOrder />} />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="importar orden de pago" />
                }
              >
                <Route
                  path="paymentOrder/import"
                  element={<ChargePaymentOrderImport />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="ver orden de pago" />
                }
              >
                <Route
                  path="paymentOrder/manager"
                  element={<ManagerPaymentOrder />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="generar orden de pago" />
                }
              >
                <Route
                  path="paymentOrder/generate/byLawyer"
                  element={<GeneratePaymentOrderByLawyer />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="generar orden de pago archivo" />
                }
              >
                <Route
                  path="paymentOrder/generate/byFile"
                  element={<ChargeNumberLegalFilePayment />}
                />
              </Route>
              <Route
                element={
                  <PrivateRoute requiredPermission="exportar reporte orden de pago" />
                }
              >
                <Route
                  path="paymentOrder/report/menu"
                  element={<PaymentOrderReport />}
                />
                <Route
                  path="paymentOrder/report/txt"
                  element={<OrderPaymentReportByDate />}
                />
                <Route
                  path="paymentOrder/report/retentions"
                  element={<RetentionReport />}
                />
              </Route>

              {/* Abogado */}
              <Route element={<PrivateRoute requiredPermission="abogado" />}>
                <Route path="lawyer" element={<Lawyer />} />
              </Route>

              {/* Usuario */}
              <Route element={<PrivateRoute requiredPermission="usuario" />}>
                <Route path="user" element={<User />} />
              </Route>

              {/* Seguridad */}
              <Route element={<PrivateRoute requiredPermission="seguridad" />}>
                <Route path="security" element={<Security />} />
              </Route>

              <Route element={<PrivateRoute requiredPermission="roles" />}>
                <Route path="roles" element={<Role />} />
              </Route>

              <Route element={<PrivateRoute requiredPermission="ver auditorias" />}>
                <Route path="security/audit" element={<AuditLogs />} />
              </Route>

              {/* Procesos */}
              <Route element={<PrivateRoute requiredPermission="procesos" />}>
                <Route path="job/history" element={<JobHistory />} />
              </Route>

              {/* Personas Arca */}
              <Route element={<PrivateRoute requiredPermission="arca" />}>
                <Route path="contributors/arca" element={<ContributorArca />} />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver personas arca" />
                }
              >
                <Route
                  path="contributors/arca/manager"
                  element={<ManagerContributorArca />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="generar archivo persona arca" />
                }
              >
                <Route
                  path="contributors/arca/generate/file"
                  element={<GenerateReportFileContributorArca />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="cargar archivo persona arca" />
                }
              >
                <Route
                  path="contributors/arca/charge/file"
                  element={<ChargeFileArcaPeople />}
                />
              </Route>

              {/* Demandas */}
              <Route element={<PrivateRoute requiredPermission="demandas" />}>
                <Route path="lawsuit" element={<Lawsuit />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="subir demandas" />}
              >
                <Route path="lawsuit/upload" element={<UploadLawsuit />} />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="actualizar demandas" />
                }
              >
                <Route
                  path="lawsuit/upload/file/update"
                  element={<ChargeUpdateLawsuit />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="subir demandas archivo" />
                }
              >
                <Route path="lawsuit/upload/file" element={<ChargeLawsuit />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="ver demandas" />}
              >
                <Route
                  path="lawsuit/get/lawyers"
                  element={<ManagerLawyerLawsuit />}
                />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="ver demandas" />}
              >
                <Route
                  path="lawsuit/lawyers/:lawyerId"
                  element={<ManagerLawsuit />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver demandas todas" />
                }
              >
                <Route path="lawsuit/all" element={<ManagerLawsuit />} />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver demandas fallidas" />
                }
              >
                <Route
                  path="lawsuit/failure"
                  element={<ManagerLawsuitFailure />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="ver demandas sin vincular" />
                }
              >
                <Route
                  path="lawsuit/unlinked"
                  element={<ManagerUnlinkedLawsuit />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="cargar demandas historicas" />
                }
              >
                <Route
                  path="lawsuit/upload/historical"
                  element={<UploadHistoricalLawsuit />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="actualizar expediente y juc id demandas" />
                }
              >
                <Route
                  path="lawsuit/update/juc"
                  element={<UpdateLawsuitJucLegalFile />}
                />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="exportar demandas" />
                }
              >
                <Route path="lawsuit/export/data" element={<ReportLawsuit />} />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="generar demandas concluidas" />
                }
              >
                <Route
                  path="lawsuit/import/concluded"
                  element={<ImportConcludedLawsuit />}
                />
              </Route>

              <Route element={<PrivateRoute requiredPermission="" />}>
                <Route
                  path="lawsuit/associate/legal/file"
                  element={<ChargeLawsuitLegalFile />}
                />
                asociar demanda expediente{" "}
              </Route>

              {/* Liquidaciones */}
              <Route element={<PrivateRoute requiredPermission="liquidaciones" />}>
                <Route path="liquidations" element={<Liquidations />} />
              </Route>
              <Route element={<PrivateRoute requiredPermission="ver liquidaciones" />}>
                <Route path="liquidations/manager" element={<ManagerLiquidations />} />
                <Route path="liquidations/municipality-report" element={<ReportMunicipalitySheet />} />
                <Route path="liquidations/liquidation-report" element={<ReportLiquidationSheet />} />
              </Route>
              <Route element={<PrivateRoute requiredPermission="ver liquidaciones comunes" />}>
                {/* Manager unificado: municipalidad + comunes en una sola grilla */}
                <Route path="individual-liquidations/manager" element={<ManagerLiquidations />} />
              </Route>
              <Route element={<PrivateRoute requiredPermission="exportar reporte liquidaciones comunes" />}>
                <Route path="individual-liquidations/report" element={<ReportIndividualLiquidationSheet />} />
              </Route>
              <Route element={<PrivateRoute requiredPermission="administrar catalogos liquidacion comun" />}>
                <Route path="settings-individual-liquidation" element={<SettingsIndividualLiquidation />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="configuracion" />}
              >
                <Route path="settings" element={<Settings />} />
              </Route>

              <Route
                element={
                  <PrivateRoute requiredPermission="administrar configuracion" />
                }
              >
                <Route path="settings/general" element={<GeneralSettings />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="ver sucursales" />}
              >
                <Route path="branches" element={<Branches />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="administrar tipos adjuntos" />}
              >
                <Route path="settings-attachment-types" element={<SettingsAttachmentTypes />} />
                <Route path="settings-attachment-sources" element={<SettingsAttachmentSources />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="ver martilleros" />}
              >
                <Route path="settings-auctioneers" element={<Auctioneers />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="ver tipos operaciones" />}
              >
                <Route path="settings-operation-types" element={<SettingsOperationTypes />} />
                <Route path="settings-legal-file-stages" element={<SettingsLegalFileStages />} />
                <Route path="settings-sentence-markers" element={<SettingsSentenceMarkers />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="administrar catalogos liquidacion" />}
              >
                <Route path="settings-liquidation" element={<SettingsLiquidation />} />
              </Route>

              <Route
                element={<PrivateRoute requiredPermission="administrar estados personalizados" />}
              >
                <Route path="settings/lawsuit-tax-status" element={<SettingsLawsuitTaxStatus />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </LocalizationProvider>
      </ToastProvider>
      <GlobalBackdrop />
    </LoadingProvider>
  );
}

export default App;
